import { request } from '../../../../../../../1stlog-ui/src/utils'
import { TBarcodeValidationResult } from './types'

export default function createValidateBarcode(url: string, isRequired = false) {
  return async function validateBarcode(value: string) {
    try {
      // console.log('validatebarcode', { value, isRequired })
      if (!value || value === '') {
        if (isRequired) {
          return i18n.t(
            'validation_barcode_is_required',
            'Bitte Barcode angeben',
          )
        }
        return null
      }
      //

      const { data } = await request<TBarcodeValidationResult>({
        method: 'post',
        url,
        data: {
          barcode1: value,
        },
      })
      // console.log('validate result', data)
      return data && !data.barcodeIsAllowed
        ? i18n.t(
            'validation_barcode_already_used',
            'Der gesuchte Barcode wurde bereits verwendet.',
          )
        : null
    } catch (err) {
      return i18n.t(
        'validation_barcode_check_error',
        'Der Barcode konnte nicht geprüft werden. Bitte versuchen Sie es später erneut.',
      )
    }
  }
}
